<template>
  <div>

    <span style="color: #53BACA; font-size: 11px; font-weight: 500; margin-left: 14px;">Clínicas</span>
    <div class="d-flex justify-content-center w-100 mt-4">
      <div class="busqueda d-flex mt-4" style="width: 50%; margin-top: 10px;" >
        <b-form-input class="input-filter" v-model="busquedaClinica"
                      placeholder="Búsqueda por  nombre o id de clínica" type="text"
                      @input="buscarClinicas"
                      @keydown.enter.prevent="buscarClinicas()"
        >
        </b-form-input>
        <b-button class="btn-extra-small" variant="info" pill>
          <span ><em class="buscar_svg" style="margin-top: 3px; height: 13px;" @click="buscarClinicas()"></em></span>
        </b-button>
      </div>
    </div>

    <div class="d-flex justify-content-left w-100 mt-2 ml-5">
      <b-form-checkbox v-model="todo" class="custom-checkbox  ml-5" stacked @input="seleccionarTodos()"/>
      <span class="textForm">Seleccionar todas las clínicas </span>
    </div>

      <div style="height: 260px; overflow-y: scroll">
        <div class="d-flex justify-content-center mt-2" >
          <b-table-simple id="clinicasLab" class="text-center mt-2" style="width: 90%;">
            <thead>
            <tr>
              <th scope="col" class="textForm"> Selección</th>
              <th scope="col" class="textForm"> ID clínica</th>
              <th scope="col" class="textForm"> Nombre </th>
              <th scope="col" class="textForm"> Recolección </th>
              <th scope="col" class="textForm"> Paquetería </th>
            </tr>
            </thead>

            <tr v-for="(clinica, index) in filteredClinicas" :key="index" >
              <td >
                <b-form-checkbox v-model="clinica.seleccionado"
                                 @input=" clinica.seleccionado ? clinica.recoleccion = true : clinica.recoleccion = false; clinica.paqueteria = false"
                                 class="custom-checkbox"/>
              </td>
              <td >{{ clinica.id }}</td>
              <td >{{ clinica.nombre }}</td>
              <td class="text-center">
                <b-form-checkbox v-model="clinica.recoleccion" class="custom-checkbox"
                                 @input=" clinica.recoleccion ? clinica.paqueteria = false : true" :disabled="!clinica.seleccionado"/>
              </td>
              <td class="text-center">
                <b-form-checkbox v-model="clinica.paqueteria" class="custom-checkbox"
                                 @input=" clinica.paqueteria ? clinica.recoleccion = false : true" :disabled="!clinica.seleccionado"/>
              </td>
            </tr>
          </b-table-simple>
        </div>
      </div>

    <div class="text-center mt-4">
      <b-button variant="outline-primary" pill size="sm"
                :disabled="!algunaClinicaSeleccionada || guardando"
                @click="guardarClinicasLab()"
      >
        <span>Guardar</span>
        <b-spinner v-if="guardando" variant="info" small/>
      </b-button>
    </div>


  </div>
</template>
<script>
export default {
  name: "ClinicasLab",
  components: {},
  props:{
    listaClinicas: Array,
    idLaboratorio: Number,
    clinicasLab: Array,
    editar: Boolean
  },
  data: () => ({
    busquedaClinica: null,
    filteredClinicas: [],
    clinicasSeleccionadas: [],
    guardando:false,

    todo: true,
  }),
  created() {
    /*this.filteredClinicas = [];*/
    this.filteredClinicas = JSON.parse(JSON.stringify( this.listaClinicas));

    if (this.editar){
      this.filteredClinicas.forEach(c => {
        this.clinicasLab.forEach(cl => {
          if (cl.id === c.id){
            c.seleccionado = cl.seleccionado;
            c.paqueteria = cl.paqueteria;
            c.recoleccion = cl.recoleccion;
          }
        })
      })


      this.filteredClinicas.forEach(c => {
        if (!c.seleccionado){
          this.todo = false
        }
      })
    }else {
      this.todo = false
    }
  },
  computed:{
    algunaClinicaSeleccionada() {
      return this.filteredClinicas.some(item => item.seleccionado === true);
    }
  },
  methods: {
    seleccionarTodos(){
      this.todo ? this.filteredClinicas.forEach(c => { c.seleccionado = true; c.recoleccion = true}) : this.filteredClinicas.forEach(c => {c.seleccionado = false; c.recoleccion = false})
    },

    guardarClinicasLab(){
      this.filteredClinicas.forEach(c => {
        if (c.seleccionado && (c.recoleccion || c.paqueteria)){
          this.clinicasSeleccionadas.push(c)
        }

      })

      const guardar = {
        idLaboratorio: this.idLaboratorio,
        clinicas: this.clinicasSeleccionadas
      }

      if (this.guardando){
        return;
      }

      this.$swal.fire({
        icon: "warning",
        html: '<p><strong>¿Estás seguro?</strong></p>',
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
        showLoaderOnConfirm: true,
        confirmButtonColor: "#EEBA6D",
        preConfirm: () => {
          this.guardando = true
          this.$http.post(this.$api + "labs/guardar/clinicasLab", guardar)
              .then((resp) => {
                if (resp.data.data) {
                  this.$swal({
                    icon: "success",
                    text: "Se guardó la información del laboratorio correctamente",
                    confirmButtonText: "OK",
                    confirmButtonColor: "#0e6ba9",
                    onClose: () => {

                      this.$emit('obtenerLaboratorios', 2);
                    }
                  })
                }
                this.guardando = false;
              })
        }
      })
    },
    buscarClinicas(){
      if (this.busquedaClinica !== ''){
        this.filteredClinicas = this.listaClinicas.filter(clinica => clinica.nombre.toLowerCase().includes(this.busquedaClinica.toLowerCase())
            || String(clinica.id).includes(this.busquedaClinica) );
      }else{
        this.filteredClinicas = this.listaClinicas
      }
    },
  }
}
</script>

<style scoped>
.textForm {
  font-size: 11px;
}





.busqueda {
  border-width: 1px;
  border-style: solid;
  border-color: #c2e7ff;
  background: #ffffff;
  margin-top: 20px;
  margin-left: 4%;
  padding-right: 2%;
  padding-left: 1%;
  border-radius: 20px;
  text-align: left;
  align-items: center;
}
</style>